var ajaxCalls = require('./ajaxCalls');
var prettyDate = require('pretty-date');
var sprintf = require('sprintf-js').sprintf;

/**
 * examLink is uses sprintf
 * var user = {
 *  name: 'Dolly',
 * }
 * sprintf('Hello %(name)s', user) // Hello Dolly
 * @param container
 * @param userId
 * @param examLink
 * @constructor
 */
var _global = {};

function ExamHistoryTable(container,userId,examLink,reviewLink,apiUrl) {
    userId = userId;
    var table = $.parseHTML('<table class="table exam-history-table"><tr><th>Exam Type</th><th>Date</th><th>Status</th><th>Score</th><th></th></tr></table>');
    $(container).append(table);
    _global = { userId : userId, apiUrl : apiUrl , table : table }
    init(examLink,reviewLink);

}

function init(examLink,reviewLink) {
    ajaxCalls.getExams(_global.userId,_global.apiUrl,function(data) {
        _(data).each(function(row) {
            $(_global.table).append(buildExamRow(row,examLink,reviewLink));
        })
    });
}
function buildExamRow(row,examLink,reviewLink) {
    var examId = row.id;
    var exam = { userId: _global.userId, examId: examId};

    if ( row.completed_at == null) {
        var status = 'In Progress';
        var score = 'Pending';
        var link = '<a class="exam-link" href="'+ sprintf(examLink,exam) +'">Continue</a>';
    } else {
        var status = 'Completed';
        var score = calcScore(row.name,row.correct,row.incorrect,row.skipped) + '%';
        var link = '<a class="review-link" href="'+ sprintf(reviewLink,exam) +'">Review</a>';
    }

    const moment = require('moment');
    const examDate = moment(row.created_at).format('MMMM Do YYYY, h:mm a');


    var tr = $.parseHTML('<tr id="'+examId+'"><td>'+ row.name+'</td><td>'+ examDate +'</td><td>'+status+'</td><td>'+score+'</td><td>'+ link +' | <a class="reset-link" href>Reset</a> | <a class="delete-link" href>Delete</a></td></tr>');

    $(tr).find('a.reset-link').click(function() {
        if (confirm('Are you sure?')) {
            ajaxCalls.resetExam(_global.userId,row.id,_global.apiUrl,function(data) {
                if (data.success) {
                    alert('Has been reset successfully!');
                }
            });
        }

    })

    $(tr).find('a.delete-link').click(function() {
        if (confirm('Are you sure?')) {
            ajaxCalls.deleteExam(_global.userId,row.id,_global.apiUrl,function(data) {
                if (data.success) {
                    $(_global.table).find('#' + examId).remove();
                }
            });
        }

    })

    return tr;
}
function calcScore(examType,correct,incorrect,skipped) {

    return Math.floor(correct/ (correct + incorrect + skipped) * 100);
}


function convertToEpoch(datestring) {
    var t = datestring.split(/[- :]/);

    return new Date(Date.UTC(t[0], t[1]-1, t[2], t[3], t[4], t[5]));

}


module.exports = ExamHistoryTable;


//////////////////
// WEBPACK FOOTER
// ./src/ExamHistoryTable.js
// module id = 290
// module chunks = 0